import {Decoder, field, number, object, string} from 'json-bouncer'

export interface BpsUser {
    id: number
    firstName: string
    lastName: string
    email: string
    customerId: number
}

export function bpsUserDecoder(): Decoder<BpsUser> {
    return object({
        id: field('id', number()),
        firstName: field('firstName', string()),
        lastName: field('lastName', string()),
        email: field('email', string()),
        customerId: field('customerId', number()),
    })
}

export function label(bpsUser: BpsUser): string {
    return `${bpsUser.lastName}, ${bpsUser.firstName}`
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/BpsUser.ts